import { Injectable } from "@angular/core";
import { IInstallmentLoanDataDTO, IInstallmentLoansHistoryResponseDTO } from '@app/shared/models/installment-loans.model';
import { IClearContext } from '@app/shared/services/context/interface/iclear-context.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InstallmentsLoansContextService implements IClearContext {
  clear(): void {
    this._installmentLoanChanged$.next(null);
    this._installmentLoans$.next(null);
  }
  private readonly _installmentLoans$ = new BehaviorSubject<IInstallmentLoansHistoryResponseDTO | null>(null);
  public installmentLoans$ = this._installmentLoans$.asObservable();
  private _installmentLoanChanged$ = new BehaviorSubject<IInstallmentLoanDataDTO | null>(null);
  public installmentLoanChanged$ = this._installmentLoanChanged$.asObservable();
  private _selectedInstallmentLoan$ = new BehaviorSubject<IInstallmentLoanDataDTO | null>(null);
  public selectedInstallmentLoan$ = this._selectedInstallmentLoan$.asObservable();

  installmentLoanChanged(installmentLoan: IInstallmentLoanDataDTO | null = null): void {
    this._installmentLoanChanged$.next(installmentLoan);
  }

  getCurrentInstallmentLoan(): IInstallmentLoanDataDTO | null {
    return this._installmentLoanChanged$.getValue();
  }

  setInstallmentLoans(value: IInstallmentLoansHistoryResponseDTO): void {
    this._installmentLoans$.next(value);
  }

  getInstallmentLoan(installlmentLoanCode: string | null): IInstallmentLoanDataDTO | null {
    return this._installmentLoans$.getValue()?.data?.find(il => il.code === installlmentLoanCode) || null;
  }

  setSelectedInstallmentLoan(installmentLoanCode: string): void {
    const installmentLoan = this.getInstallmentLoan(installmentLoanCode);
    this._selectedInstallmentLoan$.next(installmentLoan);
  }
}